<template>
	<div id="customerSerPage">
		<div style="width: 100%; height: 100%;">
			<iframe id="chatIframe" frameborder="0" height="100%" width="100%">
				
			</iframe>
		</div>
		
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	import apiConfig from '@/service/url'
	export default{
		name:'ChatBox',
		data(){
			return{
				flag:'',
				realName:'',
				mobilePhone:'',
				customerName:'',
				responsibleSeat:'',
				pushMsgSeat:'',
				groupName:'',
				nickName:'',
				questionDesc:'',
				pagereferrer:''
			}
		},
		methods:{
			calculateHeight(){
				//首先获取页面的高度
				var bodyHei = document.documentElement.clientHeight;
				//tabbar的高度为
				var tabbarHei = this.isAndriod?0:51;
				//设置内容区的高度
				var minePage = document.getElementById("customerSerPage");
				minePage.style.height = bodyHei-tabbarHei+"px";
			},
			getChatName(){
				//获取微信昵称
				_api('_chatname','.code',{mark:"getChatInfo", flag:this.flag},res=>{
					var data = res.data;
					if(data.customerName){
						this.customerName = data.customerName;
					}
					if(data.responsibleSeat){
						this.responsibleSeat = data.responsibleSeat;
					}
					if(data.pushMsgSeat){
						this.pushMsgSeat = data.pushMsgSeat;
					}
					if(data.groupName){
						this.groupName = data.groupName;
					}
					if(data.realName){
						this.realName = data.realName;
					}
					if(data.mobilePhone){
						this.mobilePhone = data.mobilePhone;
					}
					if(data.pagereferrer){
						this.pagereferrer = data.pagereferrer;
					}
					if(data.questionDesc){
						this.questionDesc = data.questionDesc;
					}
					if(data.nickName){
						this.nickName = data.nickName;
					}
					this.getChatBox();
				 },err=>{
				 	
				 })
			},
			getChatBox(){
				var showName = this.realName;
				if(this.nickName && this.realName!=this.nickName && this.realName.indexOf(this.nickName)<0
				     && this.nickName.indexOf(this.realName)<0){
					showName = this.realName + "-" + this.nickName;
				}
				showName = showName + "(" + this.customerName + ")";

				var seatInfo = this.responsibleSeat;
				if(this.pushMsgSeat && this.pushMsgSeat!=this.responsibleSeat){
					seatInfo = "推送故障坐席:" + this.pushMsgSeat + "，责任坐席:" + this.responsibleSeat;
				}

				var chatIframe = document.getElementById("chatIframe");
				
				chatIframe.setAttribute("src","https://im.sttdcloud.com/ChatClient/IndexNew?com=dmt5d2d0d618c25435b871ea412d0fc2e8f&id=portal&userName="
						+showName+"&mobilePhone="+this.mobilePhone+"&customerName="+this.customerName+"&responsibleSeat="+seatInfo
						+"&groupName="+this.groupName+"&pagereferrer=" + this.pagereferrer+"&questionDesc="+this.questionDesc);
			}
			
		},
		mounted() {
			if(this.$route.query.flag){
				this.flag=this.$route.query.flag;
			}
			this.calculateHeight();
			this.getChatName();		
		},
		computed:{
			isAndriod(){
				let u=navigator.userAgent;
				return u.indexOf('Android')>-1||u.indexOf("Linux")>-1
			}
		}
	}
</script>

<style>
	.robotinfo{
		font-size: 14px;
	}
</style>



// WEBPACK FOOTER //
// src/views/customerSer/ChatBox.vue